import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import { translate } from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';

import { distributionReturnedList } from '../../../libs/services';
import { FloatingActionButton } from 'material-ui';
import SvgIcon from 'react-icons-kit';
import { search } from 'react-icons-kit/icomoon/search';
import { bin } from 'react-icons-kit/icomoon/bin';
import {printer} from 'react-icons-kit/icomoon/printer';
import ModalDetails from './modalDetails';
import Help from '../../generics/help';

var Config = require('../../../config');

class ComponentReturnList extends Component{
    constructor(props){
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.dateCompare = this.dateCompare.bind(this);
        this.onPrint = this.onPrint.bind(this);

        this.state = {
            list:[],
            start_date: moment().format('YYYY-MM-DD'),
            end_date:moment().format('YYYY-MM-DD')
        }
    }

    componentDidMount(){
        this.onSearch();
    }

    handleChange(e){
        this.setState({[e.target.name]: e.target.value});
    }

    async onSearch(){
        var error = '';
        if(!this.dateCompare()){
            error = 'La Fecha Hasta debe ser mayor o igual a Fecha Desde'
        }

        if(error === ''){
            var request = await distributionReturnedList(
                            this.state.start_date, 
                            this.state.end_date, 
                            sessionStorage.getItem('health_facilities_id'), 
                            this.props.waiting
                        );

            if(request !== undefined){
                this.setState({list: request});
            }
        }else{
            swal('Error', error, 'error');
        }
    }

    dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;

		if(ini !== 'Invalid date' && fin !== 'Invalid date'){
			if(fin < ini){
				date_ok = false;
				document.getElementById('end_date').classList.add('error');
			}else{
				document.getElementById('end_date').classList.remove('error');
			}
		}else{
			date_ok = false;
		}		

		return date_ok;
	}

    async onPrint(id){
		this.props.waiting.handleShow('Imprimiendo...');
          
		var obj ={};
		obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
		obj.id = id;
		obj.file_type = 'distribution_return';
		obj.nEtiqueta = [0];

		var type = await this.props.getDocumentType(obj.file_type);
		
		var document;
		if(type !== undefined){
			if(type.print_type === 'template'){
				document = await this.props.printDocumentTemplate(obj, type.print_automatically);
			}else if(type.print_type === 'external'){
				document = await this.props.printDocumentExternal(obj, type.print_automatically);
			}
	
			this.props.waiting.handleClose();
		}else{
			this.props.waiting.handleClose();
		}
    }

    render(){
        const {t} = this.props;

        return(
            <div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.distribution.MAIN')} ->
						Devolución de Componentes
					</h5>
				</div>

                <Help 
                    {...this.props}
                    menu="help_distribution"
                    submenu="help_distribution_returned"
                />

                <div className='form-group'>
                    <div className='col-xs-12 form-group'>
                        <div className='col-xs-12 col-sm-2'>
                            <span className='span-min'>Fecha Desde</span>
                            <input type="date" name="start_date" id="start_date" value={this.state.start_date} 
                                onChange={(e)=>this.handleChange(e)} className='form-control' />
                        </div>
                        <div className='col-xs-12 col-sm-2'>
                            <span className='span-min'>Fecha Hasta</span>
                            <input type="date" name="end_date" id="end_date" value={this.state.end_date} 
                                onChange={(e)=>this.handleChange(e)} className='form-control' />
                        </div>
                        <div className='col-xs-12 col-sm-8' style={{marginTop:18}}>
                            <button className='btn btn-info' onClick={()=>this.onSearch()}>Buscar</button>
                            <button className='btn btn-info' style={{marginLeft:10}} onClick={()=>this.props.history.push('component_return/new')}>Nuevo</button>
                        </div>
                    </div>
                    <div className='col-xs-12 form-grouo'>
                        <Table responsive hover>
                            <thead>
                                <tr>
                                    <th>No. Devolución</th>
                                    <th>Fecha</th>
                                    <th>Cant. Unidades</th>
                                    <th>Motivo Devolición</th>
                                    <th>Observaciones</th>
                                    <th>Usuario</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.list.map((list, i)=>
                                    <tr key={i}>
                                        <td>{list.id}</td>
                                        <td>{moment(list.timestamp).format('DD/MM/YYYY')}</td>
                                        <td>{list.amount_units}</td>
                                        <td>{list.reason}</td>
                                        <td>{list.observations}</td>
                                        <td>{list.user_name}</td>
                                        <td>
                                            <FloatingActionButton backgroundColor={'#ededed'} iconStyle={{height: 33, width: 33}} title="Editar"  mini={true} 
                                                style={{marginLeft:"5px"}}
                                                onClick={()=>this.modal_details.handleShow(list.id)}    
                                            >
                                                <SvgIcon icon={search} className="icon-align"/>
                                            </FloatingActionButton>
                                            <FloatingActionButton backgroundColor={'#ededed'} 
                                                iconStyle={{height: 33, width: 33}} title="Imprimir"  mini={true} 
                                                style={{marginLeft:"5px"}}
                                                onClick={()=>this.onPrint(list.id)}
                                            >
                                                <SvgIcon icon={printer} className="icon-align"/>
                                            </FloatingActionButton>
                                            {/*}
                                            <FloatingActionButton backgroundColor={'#ededed'} iconStyle={{height: 33, width: 33}} title="Editar"  mini={true} 
                                                style={{marginLeft:"5px"}}>
                                                <SvgIcon icon={bin} className="icon-align"/>
                                            </FloatingActionButton>*/}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </div>

                <ModalDetails {...this.props} onRef={ref => this.modal_details = ref} />
            </div>
        )
    }
    
}

export default translate('translations')(ComponentReturnList);